(function () {
    "use strict";

    // @ngInject
    function CompanySettingsPreferencesControllerCtor($scope, $window, $injector, _, $translate,
                                                     CompaniesManager, UsersManager, AppStates, $sce,
                                                     DeviceService, Enums, ModalService, AnalyticsService, AutomationService,
                                                     EventService, NavigationService, $state, PopupMessageService, UiPersistenceService, ngToast, ToastService, FeaturesService) {


        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CompanySettingsPreferencesController';
        var self = this;
        this.AnalyticsService = AnalyticsService;
        this.AutomationService = AutomationService;

        this.CompaniesManager = CompaniesManager;
        this.company = this.CompaniesManager.getCurrCompany();
        this.user = UsersManager.getCurrUser();
        this.FeaturesService = FeaturesService;
        this._ = _;
        this.DeviceService = DeviceService;
        this.$scope = $scope;
        this.Enums = Enums;
        this.ModalService = ModalService;
        this.$sce = $sce;
        this.ngToast = ngToast;
        this.EventService = EventService;
        this.AppStates = AppStates;
        this.NavigationService =  NavigationService;
        this.PopupMessageService = PopupMessageService;
        this.$translate = $translate;
        this.UiPersistenceService = UiPersistenceService;
        this.ToastService = ToastService;


        this.projectTypes = angular.copy(this.company.sortedProjectTypes());
        this.source = "company_settings";
        this.tagsAnalyticsArgs = {source: "lead_source_modal", secondary_source: this.source};
        this.spacesAnalyticsArgs = {source: "company_spaces_modal", secondary_source: this.source};


        this.translationBase = 'COMPANY_SETTING.AUTOMATION_TEMPLATE';
        this.reminderTrans = this.translationBase + '.REMINDER_COPY';
        this.templateTrans = this.translationBase + '.TEMPLATE_TYPES';

        this.questionnaireTimeFrames = {
            one_week: {title: '1 week', value: 'one_week'},
            two_weeks: {title: '2 weeks', value: 'two_weeks'},
            three_weeks: {title: '3 weeks', value: 'three_weeks'},
            one_month: {title: '1 month', value: 'one_month'},
            two_months: {title: '2 months', value: 'two_months'}
        };

        this.emailNotificationTimeFrames = {
            one_day: {title: '1 day', value: 'one_day'},
            two_days: {title: '2 days', value: 'two_days'},
            three_days: {title: '3 days', value: 'three_days'},
            seven_days: {title: '7 days', value: 'seven_days'}
        };

        this.templateTypes = {
            rejection: {text: this.templateTrans + '._REJECTION_'},
            event_date: {text: this.templateTrans + '._PROJECT_DATE_'},
            thank_you: {text: this.templateTrans + '._THANK_YOU_'},
            questionnaire: {text: this.templateTrans + '._QUESTIONNAIRE_'}
        };

        this.openedTypes = [];
        this.actions = [];
        this.defaultFileExpirationData = {};

        this.buildRemindersViewModel();

        this.checkIfMobileSize = function checkIfMobileSize() {
            this.isMobileSize = this.DeviceService.checkIfMobileSize();
        };

        this.checkMobileSizeWrapper = function checkMobileSizeWrapper() {
            self.checkIfMobileSize();
            self.$scope.$apply();
        };

        self.checkIfMobileSize();

        angular.element($window).bind('resize', this.checkMobileSizeWrapper);

        $scope.$on('$destroy', function () {
            angular.element($window).off('resize', self.checkMobileSizeWrapper);
        });

        this.initProjectTypesVm();

        if (this.company.wasFullyFetched()) {
            this.gotCompany();
            this.initProjectTypesVm();
        }

        this.register(this.company, 'success', this.gotCompany);

        // redirect to /preferences if workflow is enabled
        if($state.$current.name !== this.AppStates.root_core_navigation_settings_company_preferences) {
            this.goToState(this.AppStates.root_core_navigation_settings_company_preferences);
        }

        this.$scope.$on("$destroy", function () {
            this.ngToast.dismiss(this.toastLeadSource);
        }.bind(this));
    }

    Controllers.CompanySettingsPreferencesController = Class(Controllers.BaseController, {

        constructor: CompanySettingsPreferencesControllerCtor,

        buildRemindersViewModel: function buildRemindersViewModel() {
            this.reminders = [
                this.buildReminderInfo(this.Enums.WorkflowAutomationTypes.reminder_file_sent_email_not_viewed, '._UNREAD_EMAIL_WITH_FILE_', this.emailNotificationTimeFrames, 'one_day', this.openedTypes),
                this.buildReminderInfo(this.Enums.WorkflowAutomationTypes.reminder_event_coming_up, '._UPCOMING_PROJECT_', null),
                this.buildReminderInfo(this.Enums.WorkflowAutomationTypes.reminder_unsent_file, '._UNSENT_FILE_', null),
                this.buildReminderInfo(this.Enums.WorkflowAutomationTypes.reminder_file_not_booked, '._UNACTED_FILE_', null),
                this.buildReminderInfo(this.Enums.WorkflowAutomationTypes.show_date_conflicts, '._DATE_CONFLICT_', null),
                this.buildReminderInfo(this.Enums.WorkflowAutomationTypes.add_automated_emails_to_activity, '._AUTOMATED_ACTIVITY_EMAILS_', null)
            ];
        },

        gotCompany: function gotCompany() {

            this.buildRemindersViewModel();

            this.actions = [];

            this.actions.push(
                this.AutomationService.buildActionInfo(this.company, this.Enums.WorkflowAutomationTypes.automation_send_questionnaire,
                    'pre_event_questionnaire',
                    this.translationBase + '.ACTION_COPY._PROJECT_QUESTIONNAIRE_',
                    this.translationBase + '.ACTION_COPY._PROJECT_QUESTIONNAIRE_EMAIL_',
                    true,
                    true,
                    false,
                    false,
                    this.openedTypes,
                    this.questionnaireTimeFrames)
            );
            this.actions.push(
                this.AutomationService.buildActionInfo(this.company, this.Enums.WorkflowAutomationTypes.client_file_not_viewed,
                    'client_file_not_viewed',
                    this.translationBase + '.ACTION_COPY._CLIENT_FILE_NOT_VIEWED_',
                    this.translationBase + '.ACTION_COPY._CLIENT_FILE_NOT_VIEWED_EMAIL_',
                    true,
                    false,
                    false,
                    false,
                    this.openedTypes)
            );

            this.buildDefaultExpirationData();
            this.buildAutoExpirationModel();

            this.paymentReminders = [

                this._buildPaymentReminder(
                    this.Enums.WorkflowAutomationTypes.upcoming_payment_reminder,
                    'COMPANY_SETTING.AUTOMATION_TEMPLATE.PAYMENT_REMINDERS.UPCOMING._LABEL_',
                    'COMPANY_SETTING.AUTOMATION_TEMPLATE.PAYMENT_REMINDERS.UPCOMING._DESC_',
                    'upcoming'),

                this._buildPaymentReminder(
                    this.Enums.WorkflowAutomationTypes.outstanding_payment_reminder,
                    'COMPANY_SETTING.AUTOMATION_TEMPLATE.PAYMENT_REMINDERS.OUTSTANDING._LABEL_',
                    'COMPANY_SETTING.AUTOMATION_TEMPLATE.PAYMENT_REMINDERS.OUTSTANDING._DESC_',
                    'outstanding'),

                this._buildPaymentReminder(
                    this.Enums.WorkflowAutomationTypes.due_payment_reminder,
                    'COMPANY_SETTING.AUTOMATION_TEMPLATE.PAYMENT_REMINDERS.DUE_DATE._LABEL_',
                    'COMPANY_SETTING.AUTOMATION_TEMPLATE.PAYMENT_REMINDERS.DUE_DATE._DESC_',
                    'due_date'),

                this._buildPaymentReminder(
                    this.Enums.WorkflowAutomationTypes.auto_recurring_payment_reminder,
                    'COMPANY_SETTING.AUTOMATION_TEMPLATE.PAYMENT_REMINDERS.AUTO._LABEL_',
                    'COMPANY_SETTING.AUTOMATION_TEMPLATE.PAYMENT_REMINDERS.AUTO._DESC_',
                    'auto')
            ];

        },

        _buildPaymentReminder: function _buildPaymentReminder(type, label, description, analProperty) {

            var paymentReminderInfo = this.company.getAutomationInfo(type);

            return {
                id: type,
                type: type,
                analyticsProperty: analProperty,
                label: label,
                description: description,
                automationOn: this.company.getAutomationStatus(type),
                subject: paymentReminderInfo.subject,
                body: paymentReminderInfo.html_body
            };
        },

        onPaymentReminderCustomizeClick: function onPaymentReminderCustomizeClick(paymentReminder) {
            this.ModalService.openEditPaymentReminderEmailModal(paymentReminder);
        },

        buildDefaultExpirationData: function buildDefaultExpirationData(){
            var defaultExpirationOn = this.user.default_auto_expiration_period && this.user.default_auto_expiration_period !== 'never';
            this.defaultFileExpirationData.id = this.Enums.WorkflowAutomationTypes.default_file_expiration;
            this.defaultFileExpirationData.pretext = this.translationBase + '.ACTION_COPY._DEFAULT_FILE_EXPIRATION_PRE';
            this.defaultFileExpirationData.posttext = this.translationBase + '.ACTION_COPY._DEFAULT_FILE_EXPIRATION_POST_';
            this.defaultFileExpirationData.automationOn = defaultExpirationOn;
            this.defaultFileExpirationData.showEditBox = false;
        },

        buildAutoExpirationModel: function buildAutoExpirationModel(){
            this.autoExpirationModel = {
                options: [
                    {serverValue: 'one_week', displayKey: '1 Week', description: '1 week'},
                    {serverValue: 'two_weeks', displayKey: '2 Weeks', description: '2 weeks'},
                    {serverValue: 'three_weeks', displayKey: '3 Weeks', description: '3 weeks'},
                    {serverValue: 'four_weeks', displayKey: '4 Weeks', description: '4 weeks'}
                ],
                selected: null,
            };
            this.setDefaultExpiration(this.user.default_auto_expiration_period);
        },

        setDefaultExpiration: function setDefaultExpiration(value){
            // Set default expiration
            if(value){
                angular.forEach(this.autoExpirationModel.options, function(option){
                    if(option.serverValue === value){
                        this.autoExpirationModel.selected = option;
                    }
                }.bind(this));
            } else {
                // Default value is 2 weeks
                this.autoExpirationModel.selected = this.autoExpirationModel.options[1];
                value = 'never';
            }

            // Save if automation is already on or if it is being turned off
            if(this.defaultFileExpirationData.automationOn || (!this.defaultFileExpirationData.automationOn && value === 'never')){
                var analyticsParams = {expire_period: value};
                this.user.updateAutoExpireDefault(this.user, value).then(function success() {
                    this.AnalyticsService.track(this.$scope, this.AnalyticsService.analytics_events.update_users_default_file_auto_expire, analyticsParams);
                }.bind(this), function fail(error) {
                    this.AnalyticsService.trackError(this.$scope, this.AnalyticsService.analytics_events.update_users_default_file_auto_expire, analyticsParams);
                }.bind(this));
            }
        },

        /**
         *  buildReminderInfo
         * @param type - the type of this automation
         * @param translation - the text to be shown on the automation
         * @param timeFrames - if there is a drop-down of for the automation that involves time frames these are the values
         * @param defaultTimeFrameKey - the default value of the drop-down
         * @param openedEditBoxes - a hash mapping all the opened drop-downs so if they are rebuilt (due to server returning the result) the will stay open
         * @returns {object} - the view-model of the reminder.
         */
        buildReminderInfo: function buildReminderInfo(type, translation, timeFrames, defaultTimeFrameKey, openedEditBoxes) {
            var reminderInfo = {};
            reminderInfo.id = type;
            reminderInfo.text = this.reminderTrans + translation;
            reminderInfo.automationOn = this.company.getAutomationStatus(type);
            reminderInfo.showEditBox = false;
            reminderInfo.supportsTimeFrame = !this._.isEmpty(timeFrames);

            if (timeFrames) {
                reminderInfo.timeFrame = timeFrames[this.company.getAutomationTimeFrame(type)];
                if (!reminderInfo.timeFrame) {
                    reminderInfo.timeFrame = timeFrames[defaultTimeFrameKey];
                }
                reminderInfo.timeFrames = timeFrames;
            }

            if (openedEditBoxes && openedEditBoxes[type]) {
                reminderInfo.showEditBox = true;
            } else {
                reminderInfo.showEditBox = false;
            }

            reminderInfo.timeFrames = timeFrames;
            return reminderInfo;
        },

        changeAutomationTimeFrame: function changeAutomationTimeFrame(automation, timeFrame) {
            automation.timeFrame = timeFrame;
            this.company.setAutomationTimeFrame(automation.id, timeFrame.value);
        },

        changeAutomationEventType: function changeAutomationEventType(action, eventType) {
            var key = angular.isDefined(eventType) ? eventType._id : null;
            this.AutomationService.changeAutomationEventType(this.company, action, key);
        },

        changeAutomationTemplate: function changeAutomationTemplate(action, template) {
            this.AutomationService.changeAutomationTemplate(this.company, action, template);
        },

        changeAutomationAttachment: function changeAutomationAttachment(action, attachment) {
            if (action.questionnaireTemplate) {
                this.questionnaireChosen = true;
                this.brochureChosen = false;
                this.AutomationService.changeAutomationQuestionnaire(this.company, action, attachment);
            } else if (action.brochureTemplate) {
                this.brochureChosen = true;
                this.questionnaireChosen = false;
                this.AutomationService.changeAutomationBrochure(this.company, action, attachment);
            }
        },

        changeAutomationQuestionnaire: function changeAutomationQuestionnaire(action, questionnaire){

            if (questionnaire) {

                this.questionnaireChosen = true;
                this.brochureChosen = false;
                this.AutomationService.changeAutomationQuestionnaire(this.company, action, questionnaire);

            } else {
                this.AutomationService.showMissingTemplate('questionnaire');
                var analyticsArgs = {
                    action_id: action.id
                };

                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.questionnaire_template_selected_error, analyticsArgs);
            }
        },

        changeAutomationBrochure: function changeAutomationBrochure(action, brochure){

            if (brochure) {
                this.brochureChosen = true;
                this.questionnaireChosen = false;
                this.AutomationService.changeAutomationBrochure(this.company, action, brochure);
            } else {

                this.AutomationService.showMissingTemplate('brochure');
                var analyticsArgs = {
                    action_id: action.id
                };

                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.brochure_template_selected_error, analyticsArgs);
            }
        },

        clearAutomationAttachment: function clearAutomationAttachment(action) {
            this.brochureChosen = false;
            this.questionnaireChosen = false;
            this.AutomationService.clearAutomationAttachment(this.company, action);
        },

        onAutomationActionsListItemChange: function onAutomationActionsListItemChange(action, $index) {
            if (action.supportQuestionnaire && action.automationOn) {
                this.hasQuestionnaireTemplate('actions', $index).catch(function noTemplate() {
                    action.automationOn = false;
                });
            } else {
                this.toggleAutomation('actions', $index)
            }
        },

        toggleAutomation: function toggleAutomation(automationType, index) {
            var automationObj = this[automationType][index];
            var promise = this.AutomationService.toggleAutomation(this.company, automationObj);

            if (automationObj.supportEmail || automationObj.supportsTimeFrame) {
                this.showEditBox(automationType, index);
            }

            return promise;
        },

        toggleDefaultFileExpiration: function toggleDefaultFileExpiration(){
            this.defaultFileExpirationData.showEditBox = this.defaultFileExpirationData.automationOn;
            if(this.defaultFileExpirationData.automationOn) {
                this.setDefaultExpiration(this.autoExpirationModel.selected.serverValue);
            } else{
                this.setDefaultExpiration('never');
            }
        },

        toggleDefaultFileExpirationEditBox: function toggleDefaultFileExpirationEditBox(){
            this.defaultFileExpirationData.showEditBox = !this.defaultFileExpirationData.showEditBox;
        },

        hasQuestionnaireTemplate: function hasQuestionnaireTemplate(automationType, index) {
            if (this.company.questionnaires.length > 0) {
                return this.toggleAutomation(automationType, index);
            } else {
                return this.AutomationService.showMissingTemplate('questionnaire');
            }
        },

        showEditBox: function showEditBox(automationType, index) {
            var automationStatus = this[automationType][index].automationOn;
            var automationObj = this[automationType][index];

            if (!automationStatus && automationObj.showEditBox == false) {

            } else {
                var showEditBoxTemp = !this[automationType][index].showEditBox;
                this[automationType][index].showEditBox = showEditBoxTemp;
                this.openedTypes[this[automationType][index].id] = showEditBoxTemp;
            }
        },

        gotoEmailTemplates: function gotoEmailTemplates() {
            this.goToState(this.AppStates.root_core_navigation_templatesEditor, {templateModelKey: 'email'});
        },




        /*
           // PROJECT TYPES and LEAD SOURCES //
        */

        onProjectTypeUpdate: function onProjectTypeUpdate(projectType) {

            if (projectType.editInProgress) {
                return;
            }

            projectType.editInProgress = true;

            this.CompaniesManager.updateProjectType(this.company, projectType)
                .then(this.initProjectTypesVm.bind(this))
                .catch(function error(resp) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message);
                }.bind(this))
                .finally(function final() {
                    projectType.editInProgress = false;
                });
        },

        onProjectTypeCreate: function onProjectTypeCreate(newProjectType,callback) {

            if (newProjectType.editInProgress || newProjectType.label == "") {
                return;
            }

            newProjectType.editInProgress = true;

            this.CompaniesManager.createProjectType(this.company, newProjectType.label)
                .then(this.initProjectTypesVm.bind(this))
                .catch(function error(resp) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message);
                }.bind(this))
                .finally(function final() {
                    newProjectType.editInProgress = false;
                    callback();
                }.bind(this));
        },

        onProjectTypeDelete: function onProjectTypeDelete(projectType) {
            if (projectType.editInProgress) {
                return;
            }

            var confirmMessage = this.$translate.instant('COMPANY_SETTING.PROJECT_TYPES._DELETE_CONFIRM_', {projectType: projectType.label});
            this.PopupMessageService.showConfirmPromise(this.PopupMessageService.severityTypes.info, confirmMessage).then(function confirm() {
                projectType.editInProgress = true;

                this.CompaniesManager.deleteProjectType(this.company, projectType._id)
                    .then(this.initProjectTypesVm.bind(this))
                    .catch(function error(resp) {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message);
                    }.bind(this))
                    .finally(function final() {
                        projectType.editInProgress = false;
                    });
            }.bind(this));
        },


        initProjectTypesVm: function initProjectTypesVm() {
            this.projectTypes = angular.copy(this.company.projectTypesSort());
        },

        saveLeadSources: function saveLeadSources(leadSourcesList) {
            return this.CompaniesManager.updateLeadSources(this.company, leadSourcesList, this.shouldShowLeadSourcesEditedToast());
        },

        saveProjectType: function saveLeadSources(projectTypes) {
            return this.CompaniesManager.updateProjectTypes(this.company, projectTypes);
        },

        editLeadSources: function editLeadSources() {
            this.ModalService.openEditLeadSourceModal(
                this.company.sortedLeadSources(), this.saveLeadSources.bind(this), this.tagsAnalyticsArgs)
                .then(function (edited) {
                    if(edited) {
                        if (this.shouldShowLeadSourcesEditedToast()) {
                            this._showLeadSourcesEditedToast();
                        }
                    }
                }.bind(this));
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.lead_source__modal_opened, this.tagsAnalyticsArgs);
        },

        shouldShowLeadSourcesEditedToast: function shouldShowLeadSourcesEditedToast() {
            return !this.DeviceService.checkIfMobileSize() && this.user.isCompanyOwner() && this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.showLeadSourceToast, {show: true}).show;
        },

        editProjectTypes: function editProjectTypes() {
            this.dissmissLeadSourceToast();
            this.ModalService.openEditProjectTypesModal(
                this.company.projectTypesSort(), this.saveProjectType.bind(this), this.tagsAnalyticsArgs);
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.project_type__modal_opened, this.tagsAnalyticsArgs);
        },

        editProjectDetails: function editProjectDetails(){
            this.ModalService.openProjectDetailsCustomizeModal(this.company);
        },

        saveSpaces: function saveSpaces(spaces) {

            var _spaces = spaces.map(function (space) {
                return {
                    _id: space._id,
                    name: space.label
                };
            });

            return this.CompaniesManager.updateCompanySpaces(this.company, _spaces);
        },

        editSpaces: function editSpaces(){
            if (!this.user.isVenueVendor()) {
                return;
            }

            this.loadingSpaces = true;

            this.CompaniesManager.getCompanySpaces(this.company).then(function(res) {
                this.ModalService.openEditSpacesModal(
                    this._formatSpacesData(this.company.company_spaces), this.saveSpaces.bind(this), this.spacesAnalyticsArgs);
                    this.loadingSpaces = false;
            }.bind(this));

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.company_spaces__modal_opened, this.spacesAnalyticsArgs);
        },

        _formatSpacesData: function _formatSpacesData(spaces){
            return spaces.map(function (space) {
                return {
                    _id: space._id,
                    label: space.name,
                    editable: true
                }
            });
        },

        _showLeadSourcesEditedToast: function _showLeadSourcesEditedToast() {
            var toastIcon      = '<span class="icon icon-hb-nx-bell"></span>';
            var toastTitle     = this.$translate.instant('LEADSOURCE.TOAST._TITLE_');
            var toastSubTitle  = this.$translate.instant('LEADSOURCE.TOAST._SUB_TITLE_');
            var toastCtaUpdateText = this.$translate.instant('LEADSOURCE.TOAST._UPDATE_NOW_');
            var toastTextIntro    = this.$translate.instant('LEADSOURCE.TOAST._YOU_CAN_');
            var toastTextReview    = this.$translate.instant('LEADSOURCE.TOAST._REVIEW_');

            var dismiss = '<a ng-click="companySettingsAutomationVm.dissmissLeadSourceToast()" class="lead-sources-toast__close"><span class="icon icon-hb-nx-close-16"></span></a>';
            var toastCtaUpdate = '<a class="lead-sources-toast__cta" ng-click="companySettingsAutomationVm.updateContactForm()" >' + toastCtaUpdateText + '</a>';
            var toastCtaReview = '<div>' + toastTextIntro + '<a ng-click="companySettingsAutomationVm.reviewContactForm()" >' + toastTextReview + '</a>' + toastSubTitle + toastCtaUpdate + '</div>';
            var toastContent   = '<div class="lead-sources-toast__content">' +  '<div><strong>' + toastTitle + '</strong>' + toastCtaReview + '</div>';

            this.toastLeadSourceContent   = '<div class="lead-source__toast">' + toastIcon + toastContent + dismiss +'</div>';

            this.toastLeadSource = this.ngToast.create({
                content: this.$sce.trustAsHtml(this.toastLeadSourceContent),
                className: 'lead-source_toast alert alert-info',
                dismissOnTimeout: false,
                compileContent: this.$scope
            });

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.lead_source_toast__shown, {source: "lead_source_modal", secondary_source: this.source});
        },

        reviewContactForm: function reviewEditedLeadSources() {
            this.ngToast.dismiss(this.toastLeadSource);
            this.$state.go(this.AppStates.root_core_navigation_templatesEditor, {templateModelKey: 'contactForm'});
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.lead_source_toast__closed, {source: "lead_source_modal", secondary_source: this.source, contact_form: "review"});
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.showLeadSourceToast, {show: false});
        },

        updateContactForm: function updateContactForm() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.lead_source_toast__closed, {source: "lead_source_modal", secondary_source: this.source, contact_form: "update"});
            this.CompaniesManager.publishContactFormsLeadSource(this.company)
                .then(function success() {
                    this.ngToast.dismiss(this.toastLeadSource);
                    this._showConfirmationSavedContactFormToast();
                    this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.showLeadSourceToast, {show: false});
                }.bind(this));
        },

        _showConfirmationSavedContactFormToast: function _showConfirmationSavedContactFormToast() {
            this.$timeout(function () {
                this.ToastService.showSuccess({
                    contentTranslation: 'LEADSOURCE.TOAST._CONFIRMATION_SAVED_',
                    iconCssClass: 'icon icon-hb-nx-check-mark-circle-16',
                    dismissOnTimeout: true,
                    timeout:3000
                });
            }.bind(this), 1000);
        },

        dissmissLeadSourceToast: function dissmissLeadSourceToast() {
            this.ngToast.dismiss(this.toastLeadSource);
        }


    });
}());
